/**
 * STYLING: Plain Tailwind ONLY!
 * Generate button + error display + result display for text tools.
 */

import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, Alert, AlertTitle, AlertDescription } from '@/components/v2/ui';
import { TextToolResult } from './TextToolResult';
import type { RefineIntent, TextGenerateResponse } from './textGenerationApi';

interface TextToolActionsProps {
  toolCode: string;
  loading: boolean;
  disabled: boolean;
  error: string | null;
  result: TextGenerateResponse | null;
  onGenerate: () => void;
  onRefine?: (intent: RefineIntent, sourceContent: string) => void;
  refining?: boolean;
}

export function TextToolActions({
  toolCode, loading, disabled, error, result, onGenerate, onRefine, refining,
}: TextToolActionsProps) {
  const { t } = useTranslation();

  return (
    <>
      <Button id={`text-tool-generate-btn-${toolCode}`} onClick={onGenerate} disabled={disabled} variant="primary" className="w-full"
        iconLeft={<Sparkles className="h-5 w-5" />}>
        {loading ? t('textTools.generating') : t('textTools.generateText')}
      </Button>
      {error && <Alert id={`text-tool-error-${toolCode}`} variant="error"><AlertTitle>{t('textTools.error')}</AlertTitle><AlertDescription>{error}</AlertDescription></Alert>}
      {result && result.success && (
        <TextToolResult toolCode={toolCode} result={result} onRefine={onRefine} refining={refining} />
      )}
    </>
  );
}
